module.exports = __webpack_public_path__ + "img/ic-payment-r-paypal.a6c8894d.svg";